import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function anchorScroll() {
	const links = document.querySelectorAll('a[href^="#"]');

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			const href = link.getAttribute('href');

			if (!href || href === '#') return;

			const target = document.querySelector(href);

			if (!target) return;

			e.preventDefault();

			/*
			 * 現在のScrollTrigger位置を再計算
			 */
			ScrollTrigger.refresh();

			requestAnimationFrame(() => {
				let targetY;

				/*
				 * target自身をtriggerにしている
				 * ScrollTriggerが存在するか確認
				 */
				const existingTrigger = ScrollTrigger
					.getAll()
					.find((st) => st.trigger === target);

				if (existingTrigger) {

					/*
					 * PinなどScrollTrigger管理下の要素
					 */
					targetY = existingTrigger.start;

				} else {

					/*
					 * 通常要素もScrollTriggerに
					 * 正しいスクロール位置を計算させる
					 */
					const tempTrigger = ScrollTrigger.create({
						trigger: target,
						start: 'top top',
					});

					targetY = tempTrigger.start;

					/*
					 * 計算用なので即削除
					 */
					tempTrigger.kill();
				}

				/*
				 * PC時のみ #BOOTH は
				 * 100vh分追加してスクロール
				 */
				if (
					href === '#BOOTH' &&
					window.matchMedia('(min-width: 768px)').matches
				) {
					targetY += window.innerHeight;
				}

				window.scrollTo({
					top: targetY,
					behavior: 'auto',
				});
			});
		});
	});
}